module.exports = __webpack_public_path__ + "img/12.95866784.jpg";